module.exports = __webpack_public_path__ + "static/media/bradesco.90e84feb.png";